import { flatMap, has } from "lodash";
import { useReducer } from "react";
import toast from "react-hot-toast";
import api from "../../apis/axiosInterceptor";
import { setGetLsEncryptDecryptData } from "../../shared/functions";
interface Auth {
  userData: any;
  profileData: any;
  isLoading: boolean;
  isLoggedIn: boolean;
  otpVerified: boolean;
  isSendOtpMobile: boolean;
  isVerifiedMobileOtp: boolean;
  wrongMobileOtp: boolean;
  isSendOtp: boolean;
  setNewPassword: boolean;
  userId: string;
  userName: string;
  otpData: number;
  otpDataFromMobile: object;
  error: string;
  stateData: any;
  cityData: any;
  userRoles: any;
  allCityData: any;
  // roleAccessData: any;
  roleRouteData: any;
  switchRoleData: any;
  newRoleData: any;
  loginKey: boolean;
  forceLogin: boolean;
  forceLoginMsg: string;
  cphone: number;
  cotp: number;
  croleId: string;
  membersFilterState: object;
  pSiteFilterState: object;
}

const initialArgs: Auth = {
  isLoggedIn:
    localStorage.getItem("token") !== "undefined"
      ? Boolean(localStorage.getItem("token"))
      : false,
  userData:
    localStorage.getItem("userData") !== "undefined"
      ? setGetLsEncryptDecryptData("get", "userData") === "false"
        ? {}
        : setGetLsEncryptDecryptData("get", "userData")
      : {},
  profileData: {},
  isLoading: false,
  userId: "",
  userName: "",
  otpData: 0,
  otpDataFromMobile: {},
  wrongMobileOtp: false,
  isSendOtpMobile: false,
  isVerifiedMobileOtp: false,
  isSendOtp: false,
  otpVerified: false,
  setNewPassword: false,
  error: "",
  stateData: [],
  cityData: [],
  userRoles: [],
  allCityData: [],
  // roleAccessData:
  //   localStorage.getItem("roleAccess") !== "undefined"
  //     ? setGetLsEncryptDecryptData("get", "roleAccess") === "false"
  //       ? {}
  //       : setGetLsEncryptDecryptData("get", "roleAccess")
  //     : {},
  switchRoleData: [],
  newRoleData: [],
  roleRouteData:
    localStorage.getItem("roleRoute") !== "undefined"
      ? setGetLsEncryptDecryptData("get", "roleRoute") === "false"
        ? []
        : setGetLsEncryptDecryptData("get", "roleRoute")
      : [],
  loginKey: false,
  forceLogin: false,
  forceLoginMsg: "",
  cphone: 0,
  cotp: 0,
  croleId: "",
  membersFilterState: {},
  pSiteFilterState: {},
};

const reducer = (state: Auth, action: Auth) => {
  return { ...state, ...action };
};

const useAuth = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const clearAuthState = () => {
    return { ...initialArgs };
  };

  const generateOptFromMobile = async (mobile: string) => {
    try {
      //setState({ ...state, isLoading: true });
      const result: any = await api.post("/api/users/generate-otp", {
        mobileNo: mobile,
      });

      if (result.data.status) {
        //toast.success("You're successfully logged in", { id: authToast });
        toast.success(result.data.message);
        //console.log("result.data", result.data);
        setState({
          ...state,
          // otpData: result.data.generatedOtp,
        });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        return false;
      }
    } catch (error) {
      toast.error("Soothing wan't wrong in generate-otp");
      return false;
    }
  };

  const getProfile = async () => {
    //
    try {
      const result: any = await api.get("/api/users/profile");

      if (result.data.status) {
        setState({
          ...state,
          profileData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const updateProfile = async (userName: string) => {
    try {
      const result: any = await api.post("/api/users/profile", {
        name: userName,
      });

      if (result.data.status) {
        toast.success(result.data.message);
        /* setState({
          ...state,
          otpData: result.data.generatedOtp,
        }); */
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        return false;
      }
    } catch (error) {
      toast.error("Soothing wan't wrong in generate-otp");
      return false;
    }
  };

  const checkLoginUser = async (userName: string, password: string) => {
    const authToast = toast.loading("Loading...");
    console.log("password username", password, userName);
    // userName = userName;
    // password = password;
    try {
      setState({ ...state, isLoading: true });
      const result: any = await api.post("/api/users/login", {
        userName: userName,
        password: password,
        // device_token: "admin",
        // device_type: "web",
        // type: "web",
      });

      /* By Pass the login page */
      // const result: any = {
      //   data: {
      //     status: true,
      //     message: "User Login Successfully",
      //     data: { token: "Barer ABCD" },
      //     refreshToken: "Barer ABCD",
      //     accessToken: "Barer ABCD",
      //   },
      // };

      if (result.data.status) {
        toast.success("You're successfully logged in");
        toast.dismiss();
        localStorage.setItem("token", result.data.accessToken);
        // localStorage.setItem("userData", JSON.stringify(result.data.data));
        setState({
          ...state,
          isLoggedIn: true,
          isLoading: false,
          userData: result.data.data,
        });
        setGetLsEncryptDecryptData(
          "set",
          "userData",
          JSON.stringify(result.data.data),
        );
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr, { id: authToast });
        setState({
          ...state,
          isLoggedIn: false,
          isLoading: false,
          error: errorStr,
        });
        return false;
      }
    } catch (error) {
      toast.error("Invalid userName or password", { id: authToast });
      setState({
        ...state,
        isLoggedIn: false,
        isLoading: false,
        error: "Invalid userName/password",
      });
      return false;
    }
  };

  const setOtpVerify = async (status: boolean) => {
    setState({
      ...state,
      otpVerified: status,
    });
  };

  const otpVerifyWithUsername = async (username: string, otp: number) => {
    try {
      const result: any = await api.post("/api/v1/users/verifiedOtp", {
        username: username,
        otp: otp,
      });

      if (result.data.status) {
        setState({
          ...state,
          otpVerified: true,
          isSendOtp: false,
          userName: username,
        });
        return true;
      } else {
        toast.error(result.data.message);
        setState({
          ...state,
          otpVerified: false,
          isSendOtp: false,
          error: result.data.message,
        });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({
        ...state,
        otpVerified: false,
        isSendOtp: false,
        error: error.message,
      });
      return false;
    }
  };

  const changeNewPassword = async (username: string, newPassword: string) => {
    try {
      const result: any = await api.post("/api/v1/users/forgetpassword", {
        username: username,
        newpassword: newPassword,
      });

      if (result.data.status) {
        toast.success(result.data.message);
        setState({ ...state, setNewPassword: true });
        return true;
      } else {
        toast.error(result.data.message);
        setState({
          ...state,
          setNewPassword: false,
          error: result.data.message,
        });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, setNewPassword: false, error: error.message });
      return false;
    }
  };
  const getUserRoles = async (mobileNo: string, fromApp: boolean) => {
    try {
      const result: any = await api.post("/api/users/user-roles", {
        mobileNo,
        fromApp,
      });

      if (result.data.status) {
        toast.success(result.data.message);
        setState({ ...state, userRoles: result.data.data });
        return result;
      } else {
        toast.error(result.data.message);
        setState({
          ...state,
          error: result.data.message,
        });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const clearOtpDataFromMobile = async () => {
    setState({
      ...state,
      isSendOtpMobile: false,
      isVerifiedMobileOtp: false,
      wrongMobileOtp: false,
      otpDataFromMobile: {},
    });
  };

  const updateUserData = async () => {
    setGetLsEncryptDecryptData(
      "set",
      "userData",
      JSON.stringify(state.userData),
    );
  };

  const updateStateUserData = () => {
    setState({
      ...state,
      userData:
        setGetLsEncryptDecryptData("get", "userData") === "false"
          ? {}
          : setGetLsEncryptDecryptData("get", "userData"),
    });
    return true;
  };

  const sendOtpWithMobile = async (phone: number) => {
    try {
      const result: any = await api.post("/api/users/update-number", {
        mobileNo: phone,
      });
      //console.log("sendOtpWithMobile => ", result.data);

      if (result.data.status) {
        setState({
          ...state,
          isSendOtpMobile: true,
          wrongMobileOtp: false,
          otpDataFromMobile: result?.data,
        });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({
          ...state,
          isSendOtpMobile: false,
          wrongMobileOtp: false,
          error: errorStr,
        });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, isSendOtpMobile: false, error: error.message });
      return false;
    }
  };

  const otpVerifyWithMobile = async (
    phone: number,
    otp: number,
    role: string,
    forceLogin: string = "",
  ) => {
    let otpVerifyWithUsernameToast;
    try {
      const result: any = await api.post("/api/users/verify-otp", {
        mobileNo: phone,
        otp: otp,
        role,
        forceLogin: forceLogin === "" ? state.forceLogin : forceLogin,
      });

      if (result.data.status) {
        if (result.data.loginKey) {
          setState({
            ...state,
            isLoading: false,
            cphone: phone,
            cotp: otp,
            croleId: role,
            isVerifiedMobileOtp: true,
            wrongMobileOtp: false,
            userData: result.data.data,
            loginKey: result.data.loginKey,
            forceLoginMsg: result.data.message,
            otpData: 0,
          });
          toast.dismiss();
        } else {
          toast.dismiss();
          otpVerifyWithUsernameToast = toast.success(result.data.message, {
            id: otpVerifyWithUsernameToast,
          });
          const userDataStore = setGetLsEncryptDecryptData(
            "set",
            "userData",
            JSON.stringify(result.data.data),
          );

          if (userDataStore) {
            setState({
              ...state,
              loginKey: result.data.loginKey,
              isLoggedIn: true,
              isLoading: false,
              userData: result.data.data,
              wrongMobileOtp: false,
              isVerifiedMobileOtp: true,
            });

            localStorage.setItem("token", result.data.accessToken);
            localStorage.setItem("refreshToken", result.data.refreshToken);

            return true;
          }
        }
      } else {
        toast.error(result.data.message, { id: otpVerifyWithUsernameToast });
        setState({
          ...state,
          isVerifiedMobileOtp: false,
          wrongMobileOtp: true,
          error: result.data.message,
        });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message, { id: otpVerifyWithUsernameToast });
      setState({ ...state, isVerifiedMobileOtp: false, error: error.message });
      return false;
    }
  };

  const updateState = async (payload: any) => {
    setState({ ...state, ...payload });
  };
  const verifyNewMobile = async (phone: number, otp: number) => {
    let otpVerifyWithUsernameToast;
    try {
      const result: any = await api.post("/api/users/verify-new-number", {
        mobileNo: phone,
        otp: otp,
      });

      if (result.data.status) {
        otpVerifyWithUsernameToast = toast.success(result.data.message, {
          id: otpVerifyWithUsernameToast,
        });
        return true;
      } else {
        toast.error(result.data.message, { id: otpVerifyWithUsernameToast });
        /* setState({
          ...state,
          isVerifiedMobileOtp: false,
          wrongMobileOtp: true,
          error: result.data.message,
        }); */
        return false;
      }
    } catch (error: any) {
      toast.error(error.message, { id: otpVerifyWithUsernameToast });
      //setState({ ...state, isVerifiedMobileOtp: false, error: error.message });
      return false;
    }
  };

  /* Logout Old Code Start */
  /* 
  const logout = async () => {
    localStorage.clear();
    localStorage.clear();
    setState({ ...state, isLoggedIn: false });

    return true;
  };
*/
  /* Logout Old Code End */

  const logout = async () => {
    try {
      const response: any = await api.patch(`/api/users/logout`);

      if (response.data.status) {
        setState({ ...state, isLoggedIn: false, userData: {}, otpData: 0 });
        localStorage.clear();
        toast.success(response.data.message);
      } else {
        setState({ ...state, isLoggedIn: false, userData: {} });
        localStorage.clear();
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }

    return true;
  };

  const contact = async (param: any) => {
    try {
      const paramObject = {
        ...param,
      };
      const result: any = await api.post("/api/v1/users/contact", paramObject);

      if (result.data.status) {
        toast.success(result.data.message);
        setState({ ...state, setNewPassword: true });
        return true;
      } else {
        toast.error(result.data.message);
        setState({
          ...state,
          setNewPassword: false,
          error: result.data.message,
        });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, setNewPassword: false, error: error.message });
      return false;
    }
  };

  //set profile image service

  const setProfileImageData = async (imgFormData: any) => {
    try {
      const result: any = await api.post(
        `/api/users/profileImage`,

        imgFormData,

        { headers: { "Content-Type": "multipart/form-data" } },
      );

      //console.log("Profile Photo:  result.data: ", result.data);

      if (result.data.status) {
        toast.success(result.data.message);

        return result.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;

        toast.error(errorStr);

        return { status: false };
      }
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message
          ? error.response.data.message
          : error.message,
      );

      return { status: false };
    }
  };

  /* get state list */
  const getStateData = async () => {
    try {
      //state.stateData = [];
      setState({
        ...state,
        stateData: [],
      });

      const result: any = await api.get("/api/users/state");

      if (result.data.status) {
        setState({
          ...state,
          stateData: result.data.data,
        });

        return true;
      } else {
        /* const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message; */
        //setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      //setState({ ...state, error: error.message });
      return false;
    }
  };

  /* get city list */
  const getCityData = async (id: any) => {
    try {
      const result: any = await api.get(`/api/users/city?state_id=${id}`);

      if (result.data.status) {
        setState({
          ...state,
          cityData: result.data.data,
        });

        return true;
      } else {
        /* const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message; */
        //setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      //setState({ ...state, error: error.message });
      return false;
    }
  };

  /* City API without State Start */
  const getAllCityData = async () => {
    try {
      const result: any = await api.get(`/api/users/city`);

      if (result.data.status) {
        setState({
          ...state,
          allCityData: result.data.data,
        });

        return true;
      } else {
        /* const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message; */
        //setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      //setState({ ...state, error: error.message });
      return false;
    }
  };

  // const getRoleAccess = async () => {
  //   try {
  //     const userData: any =
  //       localStorage.getItem("userData") !== "undefined"
  //         ? setGetLsEncryptDecryptData("get", "userData") === "false"
  //           ? {}
  //           : setGetLsEncryptDecryptData("get", "userData")
  //         : {};
  //     const roleId = userData
  //       ? userData?.currentAccount?.userRole?._id
  //       : state.userData?.currentAccount?.userRole?._id;

  //     if (!roleId) return false;

  //     const result: any = await api.get(`/api/role-access/get/${roleId}`);

  //     if (result.data.status) {
  //       setState({
  //         ...state,
  //         // roleAccessData: result.data.data,
  //       });
  //       return result.data.data;
  //     } else {
  //       return false;
  //     }
  //   } catch (error: any) {
  //     return false;
  //   }
  // };
  const getRoleRoute = async () => {
    try {
      const userData: any =
        localStorage.getItem("userData") !== "undefined"
          ? setGetLsEncryptDecryptData("get", "userData") === "false"
            ? {}
            : setGetLsEncryptDecryptData("get", "userData")
          : {};
      const roleId = userData
        ? userData?.currentAccount?.userRole?._id
        : state.userData?.currentAccount?.userRole?._id;

      if (!roleId) return false;

      const result: any = await api.get(
        `/api/role-access/get-by-role/${roleId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          roleRouteData: result.data.data,
        });
        return result.data.data;
      } else {
        return false;
      }
    } catch (error: any) {
      return false;
    }
  };
  // const getSwitchRoles = async (roleId: string) => {
  //   try {
  //     if (!roleId) return false;

  //     const result: any = await api.get(`/api/accounts/get/${roleId}`);

  //     if (result.data.status) {
  //       // toast.success(result.data.message);
  //       setState({ ...state, switchRoleData: result.data.data });
  //       return result;
  //     } else {
  //       toast.error(result.data.message);
  //       setState({
  //         ...state,
  //         error: result.data.message,
  //       });
  //       return false;
  //     }
  //   } catch (error: any) {
  //     // toast.error(error.message);
  //     setState({ ...state, error: error.message });
  //     return false;
  //   }
  // };
  const switchProfile = async (roleId: string) => {
    try {
      const result: any = await api.patch(
        `/api/accounts/switch-account/${roleId}`,
      );

      if (result.data.status) {
        toast.success(result.data.message);
        setState({
          ...state,
          isLoggedIn: true,
          isLoading: false,
          wrongMobileOtp: false,
          userData: result.data.data,
        });
        setGetLsEncryptDecryptData(
          "set",
          "userData",
          JSON.stringify(result.data.data),
        );
        localStorage.setItem("token", result.data.data.accessToken);
        localStorage.setItem("refreshToken", result.data.data.refreshToken);
        // await roleAccess();
        await roleRoute();
        /* setState({
          ...state,
          isVerifiedMobileOtp: true,
          wrongMobileOtp: false,
        }); */
        return true;
      } else {
        setState({
          ...state,
          isVerifiedMobileOtp: false,
          wrongMobileOtp: true,
          error: result.data.message,
        });
        return false;
      }
    } catch (error) {
      console.log(error);
    }
    return true;
  };

  const getLatestRouteData = () => {
    const routeData =
      localStorage.getItem("roleRoute") !== "undefined"
        ? setGetLsEncryptDecryptData("get", "roleRoute") === "false"
          ? []
          : setGetLsEncryptDecryptData("get", "roleRoute")
        : [];
    return routeData;
  };

  const validateAccessHook = (options: any) => {
    const { moduleId, action } = options;
    const routeData: any = getLatestRouteData() || [];
    const matchRoute = routeData.find((ele: any) => ele._id === moduleId);
    const access =
      matchRoute &&
      matchRoute.userRoleAccess &&
      matchRoute.userRoleAccess.length &&
      matchRoute.userRoleAccess[0][action];
    return access;
  };

  // const roleAccess = async () => {
  //   try {
  //     const response = await getRoleAccess();

  //     setGetLsEncryptDecryptData("set", "roleAccess", JSON.stringify(response));
  //   } catch (error) {
  //     toast.error("Error while fetching role access data");
  //   }
  // };

  const roleRoute = async () => {
    try {
      const roleResponse = await getRoleRoute();

      setGetLsEncryptDecryptData(
        "set",
        "roleRoute",
        JSON.stringify(roleResponse),
      );
    } catch (error) {
      toast.error("Error while fetching role access data");
    }
  };

  const getLatestUserData = () => {
    const userData: any =
      localStorage.getItem("userData") !== "undefined"
        ? setGetLsEncryptDecryptData("get", "userData") === "false"
          ? {}
          : setGetLsEncryptDecryptData("get", "userData")
        : {};
    return userData;
  };
  const getLatestToken = () => {
    const accessToken: any = localStorage.getItem("token");
    return { accessToken };
  };

  /* const someAsyncFunction = async (data: object) => {
    // Simulate async operation (e.g., API call)
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(data); // Return the processed data
      }, 50); // Delay of 100ms
    });
  }; */

  const setMembersFilterState = async (data: object, flg: boolean = false) => {
    if (flg) {
      setState({
        ...state,
        membersFilterState: {},
      });
      state.membersFilterState = {};
    } else {
      const processedData: any = data; //await someAsyncFunction(data); // Replace with your async logic
      //console.log("updatedFilterState >>>", processedData);
      setState({ ...state, membersFilterState: processedData });
    }
  };

  const setPSiteFilterState = async (data: object, flg: boolean = false) => {
    if (flg) {
      setState({
        ...state,
        pSiteFilterState: {},
      });
      state.pSiteFilterState = {};
    } else {
      const processedData: any = data; //await someAsyncFunction(data); // Replace with your async logic
      //console.log("updatedFilterState >>>", processedData);
      setState({ ...state, pSiteFilterState: processedData });
    }
  };

  return {
    generateOptFromMobile,
    clearOtpDataFromMobile,
    updateUserData,
    updateStateUserData,
    sendOtpWithMobile,
    changeNewPassword,
    otpVerifyWithUsername,
    setOtpVerify,
    otpVerifyWithMobile,
    checkLoginUser,
    updateState,
    logout,
    contact,
    getProfile,
    updateProfile,
    verifyNewMobile,
    setProfileImageData,
    getStateData,
    getCityData,
    getUserRoles,
    getAllCityData,
    // getRoleAccess,
    getRoleRoute,
    // getSwitchRoles,
    switchProfile,
    getLatestRouteData,
    validateAccessHook,
    roleRoute,
    // roleAccess,
    getLatestUserData,
    getLatestToken,
    setMembersFilterState,
    setPSiteFilterState,
    clearAuthState,
    ...state,
  };
};

export default useAuth;
